<template>
  <div class="col-sm-12 attendance-card-col">
    <div class="attendance-card">
      <div class="attendance-header">
        <span class="attendance-title">My Attendance (Last 7 days)</span>
        <a @click="goToPage('my-attendance')" class="attendance-see-all">See Details</a>
      </div>

      <div class="table-responsive">
        <table class="attendance-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>In Time</th>
              <th>Out Time</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in tableItems" :key="i" :class="getRowStatus(item.status)">
              <td>{{ item.format_calendar_date }}</td>
              <td>{{ item.in_time }}</td>
              <td>{{ item.out_time }}</td>
              <td>{{ item.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <Loader v-if="loading"/>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {useStore} from "vuex";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import {useRoute, useRouter} from "vue-router";
import Loader from '@/components/atom/LoaderComponent'
import handleRedirectToPage from "@/services/modules/redirectToPage";

const store = useStore()
const $route = useRoute();
const router = useRouter();
const tableItems = ref([])
const loading = ref(false)
const {goToPage} = handleRedirectToPage()

const {
  fetchAttendanceList,
} = handleHrPayroll()

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

const fetchAttendance = () => {
  loading.value = true
  let query = getQuery();
  query += `&limit_days=7`
  query += `&is_all=true`
  query += `&status=approved`

  const fetchAttendance = fetchAttendanceList(query);
  fetchAttendance.then(res => {
     if (!res.status){
       tableItems.value = [];
       return;
     }

     tableItems.value = res.data;
  }).finally(() => {
    loading.value = false
  });
}

const getRowStatus = (status) =>  {
  if (!status) return {};
  return {
    'bg-color': ['H', 'W', 'LT','L'].some(value => status.split('/').includes(value)),
    'bg-red': status === 'A',
  };
}

onMounted(() => {
  fetchAttendance()
})

</script>

<style scoped>
.attendance-card-col {
  padding: 8px;
}

.attendance-card {
  background-color: #ffffff;
  border: 1px solid #e8e9ec;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(34, 41, 47, 0.06);
  padding: 20px;
  position: relative;
}

.attendance-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 14px;
  margin-bottom: 16px;
  border-bottom: 1px solid #f0f1f4;
}

.attendance-title {
  font-size: 14px;
  font-weight: 700;
  color: #2b2b2b;
}

.attendance-see-all {
  font-size: 12px;
  font-weight: 600;
  color: #16a085;
  cursor: pointer;
}

.attendance-table {
  width: 100%;
  font-size: 13px;
  text-align: center;
  border-collapse: collapse;
}

.attendance-table thead th {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #6e6b7b;
  padding: 10px 8px;
  border-bottom: 1px solid #f0f1f4;
}

.attendance-table tbody td {
  padding: 9px 8px;
  color: #4a4a4a;
  border-bottom: 1px solid #f5f6f8;
}

.attendance-table tbody tr:last-child td {
  border-bottom: none;
}
</style>

<style>
.bg-color {
  --bs-bg-opacity: 1;
  background-color: rgb(16 108 223 / 20%) !important;
}
.bg-red {
  --bs-bg-opacity: 1;
  background-color: rgb(165 45 90 / 12%) !important;
  color: red;
}
</style>